import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { AddIcon, LockOutlinedIcon } from 'icons/materialIcons'; // Centralized icon
import getIconForType from 'utils/icons/getIconForType'; // Adjust the path as needed

const TeamContactLinkItem = ({ text, onClick, type, disabled = false }) => {
    const button = (
        <Button
            variant="outlined"
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            sx={{
                backgroundColor: disabled ? '#f9f9f9' : '#f5f5f5', // Lighter shade when disabled
                textTransform: 'none', // No capitalization
                fontSize: '0.75rem', // Smaller font size
                fontWeight: 'bold', // Make text bold
                borderColor: disabled ? '#e0e0e0' : '#ddd', // Lighter border when disabled
                color: disabled ? '#999' : '#555', // Grayed out text when disabled
                display: 'flex', // Flexbox for layout
                alignItems: 'center', // Center items vertically
                gap: 1, // Space between elements
                opacity: disabled ? 0.6 : 1, // Reduced opacity when disabled
                cursor: disabled ? 'not-allowed' : 'pointer',
                '&:hover': {
                    backgroundColor: disabled ? '#f9f9f9' : '#ececec', // No hover effect when disabled
                },
            }}
            startIcon={disabled ? <LockOutlinedIcon sx={{ fontSize: '0.875rem' }} /> : getIconForType(type)} // Lock icon when disabled
            endIcon={disabled ? null : <AddIcon />} // No plus icon when disabled
        >
            {text}
        </Button>
    );

    if (disabled) {
        return (
            <Tooltip title="This link type is restricted by your subteam">
                <span>{button}</span>
            </Tooltip>
        );
    }

    return button;
};

export default TeamContactLinkItem;